import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static values = {
    url: String
  }
  static targets = ['templateSelect', 'categorySelect', 'messageTextarea', 'submitButton']

  loadTemplate() {
    const selectedOption = this.templateSelectTarget.options[this.templateSelectTarget.selectedIndex];
    if (selectedOption.dataset.body) {
      this.messageTextareaTarget.value = selectedOption.dataset.body;
    } else {
      this.messageTextareaTarget.value = '';
    }
  }

  call() {
    this.disableForm();
    const checkedRadio = this.categorySelectTargets.find(radio => radio.checked);
    post(this.urlValue, {
      body: {
        body: this.messageTextareaTarget.value,
        category: checkedRadio ? checkedRadio.value : '' },
      responseKind: 'turbo-stream'
    })
  }

  disableForm() {
    this.messageTextareaTarget.classList.add('tw-opacity-75', 'tw-bg-gray-200', 'tw-pointer-events-none');
    this.submitButtonTarget.disabled = true;
  }
}
